/**
 * Search Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseReplacerView = require('common/base.replacer.view');

    module.exports = BaseReplacerView.extend({

        getGameConfigurations: function() {
            return _.toArray(Playtech.Variables.gamesConfiguration);
        },

        getSearchWidgetOptions: function() {
            return {
                labelField: 'name',
                source: {
                    data: this.getGameConfigurations(),
                    fields: ['name']
                },
                type: 'game'
            };
        },

        render: function() {
            this.$el.html(this.tmpl('search', {}));
            var $search = this.$('.fn-search');

            this.detachWidget($search, 'search');
            this.attachWidget($search.search(this.getSearchWidgetOptions()));

            return this;
        }

    }, {
        nameOfReplacers: [
            'SEARCH'
        ]
    });
});
